// extracted by mini-css-extract-plugin
export default {"history":"History_history__kFPAi","left":"History_left__YxIOe","section_title":"History_section_title__cUXO1","title":"History_title__lGNR6","right":"History_right__0TRee"};